// Code generated by Slice Machine. DO NOT EDIT.

import { defineAsyncComponent } from "vue";
import { defineSliceZoneComponents } from "@prismicio/vue";

export const components = defineSliceZoneComponents({
  about: defineAsyncComponent(() => import("./About/index.vue")),
  anvantages_cards: defineAsyncComponent(
    () => import("./AdvantagesCards/index.vue"),
  ),
  cta: defineAsyncComponent(() => import("./Cta/index.vue")),
  ecosystem: defineAsyncComponent(() => import("./Ecosystem/index.vue")),
  event_timer: defineAsyncComponent(() => import("./EventTimer/index.vue")),
  for_athletes: defineAsyncComponent(() => import("./ForAthletes/index.vue")),
  hero_screen: defineAsyncComponent(() => import("./HeroScreen/index.vue")),
  how_it_works: defineAsyncComponent(() => import("./HowItWorks/index.vue")),
  map: defineAsyncComponent(() => import("./Map/index.vue")),
  our_vision: defineAsyncComponent(() => import("./OurVision/index.vue")),
  preference: defineAsyncComponent(() => import("./Preference/index.vue")),
});
